import SignUpModal from './SignUpModal';

export * from './SignUpModal';
export default SignUpModal;
